import React from 'react';
import ReportForm from '../ReportForm/ReportForm';

/**
 * Starts the report of the open reporting window. The form picks up the draft
 * the Young Crew left behind earlier, when there is one.
 */
const AddReport = () => <ReportForm mode="create" />;

export default AddReport;
